import Reflux from 'reflux';
import Actions from './actions';
import Tracking from 'medscape/tracking';
import Utils from 'medscape/utils';
export default class ZoomLayerStore extends Reflux.Store
{
    constructor(props)
    {
        super();
        this.state = this.getInitialState();
        this.listenables = Actions;
    }
    getInitialState(){
        return {
          modalIsOpen: false,
          settings: {
                "image":{
                    "src": "",
                    "title": "",
                    "alt": "",
                    "className": "",
                    "id": ""
                    },
                "label": "",
                "caption": ""
            }
        }
    }

    onOpen(settings=this.settings){
        Tracking.track("zoom_layer-open");
        this.setState({
            modalIsOpen: true,
            settings: settings
        })
    }
    onClose(){
        Tracking.track("zoom_layer-close");
        this.setState(this.getInitialState());
    }
}




// WEBPACK FOOTER //
// ./src/app/zoom-images/zoom-layer/store.js